import T from "./types";

export const previewModeON = () => ({
  type: T.ON_PREVIEW_MODE,
});

export const previewModeOFF = () => ({
  type: T.OFF_PREVIEW_MODE,
});
